import React, { useEffect, lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const roleHome = {
  admin: "/admin",
  teacher: "/teacher",
  staff: "/teacher",
  student: "/student",
  parent: "/parent",
};

const ProtectedRoute = ({ children, role }) => {
  const { loading, isAuthenticated, user } = useSelector((s) => s.auth);

  console.log("ProtectedRoute Debug:", { loading, isAuthenticated, user });

  // 1. Loading లో ఉన్నప్పుడు: కేవలం లోడింగ్ స్క్రీన్ చూపించు, నావిగేట్ చేయకు
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  // 2. Loading పూర్తయ్యాక మాత్రమే: isAuthenticated ని చెక్ చేయి
  if (!isAuthenticated) {
    console.log("ProtectedRoute: Redirecting to login because auth is false");
    return <Navigate to="/login" replace />;
  }

  // 3. Admin access logic...
  if (user?.role === "admin") return children;

  const effectiveRole = user?.role === "staff" ? "teacher" : user?.role;
  if (role && effectiveRole !== role) {
    return <Navigate to={roleHome[user?.role] || "/login"} replace />;
  }

  return children;
};

export default ProtectedRoute;
